import { Trans } from '@lingui/react/macro';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/common/components/ui/button';
import { DialogDescription, DialogTitle } from '@/common/components/ui/dialog';

export interface ConfirmDialogOptions {
  title: string;
  description: string;
  confirmLabel: string;
}

export function ConfirmDialogContent({
  title,
  description,
  confirmLabel,
  onConfirm,
  onCancel,
}: ConfirmDialogOptions & { onConfirm: () => void; onCancel: () => void }) {
  return (
    <>
      <div className="flex items-start gap-4">
        <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-destructive/10">
          <AlertTriangle size={20} className="text-destructive" />
        </div>
        <div>
          <DialogTitle className="text-base font-semibold">{title}</DialogTitle>
          <DialogDescription className="mt-1 text-sm">{description}</DialogDescription>
        </div>
      </div>
      <div className="flex justify-end gap-3 pt-2">
        <Button variant="outline" onClick={onCancel}>
          <Trans>Cancel</Trans>
        </Button>
        <Button variant="destructive" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </div>
    </>
  );
}
